/**
 * Secret room configuration
 * Ported from OriginalGame/src/data/secretRooms.js
 */

import type { SecretRoomConfigMap } from '@/common/types/site.types'

export const secretRooms: SecretRoomConfigMap = {
  "1": {
    "id": 1,
    "maxCount": "10",
    "probability": "0.1",
    "minRooms": 2,
    "maxRooms": 3,
    "minDifficultyOffset": -1,
    "maxDifficultyOffset": 1,
    "produceValue": 11,
    "produceList": [{
      "itemId": "1101**",
      "weight": 1
    }, {
      "itemId": "1103083",
      "weight": 1
    }, {
      "itemId": "1105011",
      "weight": 1
    }, {
      "itemId": "1105022",
      "weight": 1
    }, {
      "itemId": "1305011",
      "weight": 10
    }, {
      "itemId": "1301041",
      "weight": 10
    }, {
      "itemId": "1301052",
      "weight": 0
    }, {
      "itemId": "1301063",
      "weight": 0
    }, {
      "itemId": "1104011",
      "weight": 0
    }, {
      "itemId": "1104021",
      "weight": 0
    }, {
      "itemId": "1104043",
      "weight": 0
    }]
  },
  "2": {
    "id": 2,
    "maxCount": "10",
    "probability": "0.1",
    "minRooms": 2,
    "maxRooms": 4,
    "minDifficultyOffset": 0,
    "maxDifficultyOffset": 1,
    "produceValue": 11,
    "produceList": [{
      "itemId": "1101**",
      "weight": 1
    }, {
      "itemId": "1103083",
      "weight": 1
    }, {
      "itemId": "1105011",
      "weight": 1
    }, {
      "itemId": "1105022",
      "weight": 1
    }, {
      "itemId": "1305011",
      "weight": 10
    }, {
      "itemId": "1301041",
      "weight": 10
    }, {
      "itemId": "1301052",
      "weight": 0
    }, {
      "itemId": "1301063",
      "weight": 0
    }, {
      "itemId": "1104011",
      "weight": 0
    }, {
      "itemId": "1104021",
      "weight": 0
    }, {
      "itemId": "1104043",
      "weight": 0
    }, {
      "itemId": "1101073",
      "weight": 0
    }]
  },
  "3": {
    "id": 3,
    "maxCount": "10",
    "probability": "0.1",
    "minRooms": 2,
    "maxRooms": 5,
    "minDifficultyOffset": 1,
    "maxDifficultyOffset": 1,
    "produceValue": 20,
    "produceList": [{
      "itemId": "1101**",
      "weight": 0
    }, {
      "itemId": "1103083",
      "weight": 0
    }, {
      "itemId": "1105011",
      "weight": 0
    }, {
      "itemId": "1105022",
      "weight": 0
    }, {
      "itemId": "1305011",
      "weight": 10
    }, {
      "itemId": "1301041",
      "weight": 10
    }, {
      "itemId": "1301052",
      "weight": 10
    }, {
      "itemId": "1301063",
      "weight": 0
    }, {
      "itemId": "1104011",
      "weight": 0
    }, {
      "itemId": "1104021",
      "weight": 0
    }, {
      "itemId": "1104043",
      "weight": 0
    }, {
      "itemId": "1101073",
      "weight": 0
    }]
  },
  "4": {
    "id": 4,
    "maxCount": "15",
    "probability": "0.05",
    "minRooms": 2,
    "maxRooms": 6,
    "minDifficultyOffset": 1,
    "maxDifficultyOffset": 1,
    "produceValue": 54,
    "produceList": [{
      "itemId": "1101**",
      "weight": 0
    }, {
      "itemId": "1103083",
      "weight": 0
    }, {
      "itemId": "1105011",
      "weight": 0
    }, {
      "itemId": "1105022",
      "weight": 0
    }, {
      "itemId": "1305011",
      "weight": 20
    }, {
      "itemId": "1301041",
      "weight": 5
    }, {
      "itemId": "1301052",
      "weight": 5
    }, {
      "itemId": "1301063",
      "weight": 10
    }, {
      "itemId": "1104011",
      "weight": 0
    }, {
      "itemId": "1104021",
      "weight": 0
    }, {
      "itemId": "1104043",
      "weight": 0
    }, {
      "itemId": "1101073",
      "weight": 0
    }]
  },
  "5": {
    "id": 5,
    "maxCount": "10",
    "probability": "0.1",
    "minRooms": 2,
    "maxRooms": 5,
    "minDifficultyOffset": 1,
    "maxDifficultyOffset": 1,
    "produceValue": 86,
    "produceList": [{
      "itemId": "1101073",
      "weight": 0
    }, {
      "itemId": "1103083",
      "weight": 0
    }, {
      "itemId": "1104011",
      "weight": 10
    }, {
      "itemId": "1305011",
      "weight": 0
    }]
  },
  "6": {
    "id": 6,
    "maxCount": "30",
    "probability": "0.04",
    "minRooms": 2,
    "maxRooms": 5,
    "minDifficultyOffset": 1,
    "maxDifficultyOffset": 1,
    "produceValue": 86,
    "produceList": [{
      "itemId": "1101073",
      "weight": 0
    }, {
      "itemId": "1103083",
      "weight": 0
    }, {
      "itemId": "1104011",
      "weight": 10
    }, {
      "itemId": "1305011",
      "weight": 0
    }]
  }
}

